import * as actionTypes from '../../actionTypes';
import axios from '../../../../_services/api/axios';

export const calculatorJobsFetchStart = (searched = false) => {
    return {
        type: actionTypes.CALCULATOR_JOBS_FETCH_START,
        searched: searched
    };
};

export const calculatorJobsFetchSuccess = (jobs) => {
    return {
        type: actionTypes.CALCULATOR_JOBS_FETCH_SUCCESS,
        jobs: jobs
    };
};

export const calculatorJobsFetchFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOBS_FETCH_FAIL,
        error: error
    };
};

export const calculatorJobsFetch = (searchData = {}) => {
    return dispatch => {
        let searchParams = "";
        let searchParamsArray = [];
        let searched = false;
        if(searchData.searchText) {
            searchParamsArray.push("searchText="+searchData.searchText);
        }
        if(searchData.start_date) {
            searchParamsArray.push("start_date="+searchData.start_date);
        }
        if(searchData.end_date) {
            searchParamsArray.push("end_date="+searchData.end_date);
        }
        if(searchParamsArray.length) {
            searchParams = '?' + searchParamsArray.join('&');
            searched = true;
        }
        dispatch(calculatorJobsFetchStart(searched));
        axios.get( '/production/calculator/jobs' + searchParams)
            .then( response => {
                dispatch( calculatorJobsFetchSuccess( response.data.list) );
            } )
            .catch( error => {
                if(error.length && error.length === 1) {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "jobs", key: error[0].key, message: error[0].message, type: 'error'} } ); 
                }
                else {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "jobs", key: "default", message: "There was an error, please try it again later.", type: 'error', obj: error} } ); 
                }
                dispatch( calculatorJobsFetchFail( error ) );              
            } );
    };
};


// WEBPACK FOOTER //
// ./src/_store/actions/calculator/jobs/jobs.js